import { RightNavigationButton } from "@components/Layouts/CatalogLayout/RightNavigation/RightNavigationButton";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { useCatalogViewsAccess } from "@ext/catalog/views/logic/hooks/useCatalogViews";
import { CATALOG_VIEW_PANEL_ID } from "@ext/catalog/views/models/consts";
import t from "@ext/localization/locale/translate";
import { usePanelToggle } from "@ui-kit/FloatingPanel";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";
import { cloneElement, memo, type ReactElement, useRef } from "react";

const VIEW_TRIGGER_TEST_ID = "catalog-view-trigger";

interface CatalogViewProps {
	trigger?: ReactElement;
}

export const CatalogView = memo(({ trigger }: CatalogViewProps) => {
	const triggerRef = useRef<HTMLButtonElement>(null);
	const { isOpen, toggle } = usePanelToggle(CATALOG_VIEW_PANEL_ID, triggerRef);
	const { canSeeCatalogViews } = useCatalogViewsAccess();
	const appliedView = useCatalogPropsStore((state) => state.data?.resolvedView);

	if (!canSeeCatalogViews) return null;

	if (trigger)
		return cloneElement(trigger, {
			ref: triggerRef,
			onClick: toggle,
			active: isOpen,
			"data-testid": VIEW_TRIGGER_TEST_ID,
		} as never);

	return (
		<RightNavigationButton
			data-state={isOpen ? "open" : "closed"}
			data-testid={VIEW_TRIGGER_TEST_ID}
			onClick={toggle}
			ref={triggerRef}
			startIcon="eye"
			trailingIcon="chevron-down"
		>
			<TextOverflowTooltip>{appliedView?.name || t("catalog.views.trigger")}</TextOverflowTooltip>
		</RightNavigationButton>
	);
});

CatalogView.displayName = "CatalogView";
